import {Field} from 'formik';
import {FormikSelect} from '@flexinet/ui-components';
import {EXECUTION_STATUS_OPTIONS} from '../../config/executionStatuses';

export const FilterFormComponent = () => {
    return (
        <>
            <Field
                name="lastExecutionStatus"
                label="Last Execution Status"
                description="Show only pipelines whose last run ended in this state"
                component={FormikSelect}
                data={EXECUTION_STATUS_OPTIONS}
                clearable
                my="md"
            />
        </>
    );
};

